module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.22.0@babel-runtime/core-js/object/define-property.js
 ** module id = 672
 ** module chunks = 0
 **/